<template>
	<div class="trun-role">
		<div class="page-handle">
			<div class="left">
				<a-button type="primary" @click="visible=true">添加作业设置</a-button>
				<a-button type="primary" @click="addAnalyze">设置分析人员</a-button>
			</div>
			<div class="right">
				<a-dropdown overlayClassName="hospital-dropdown-overlay" class="hospital-dropdown-link">
					<a class="ant-dropdown-link">
						{{searchLableKey}}
						<a-icon type="down"/>
					</a>
					<a-menu slot="overlay" style="height: 300px; overflow: hidden; overflow-y: scroll;"
					        @click="onClickSearchApplyItemKey">
						<a-menu-item key="-1">
							<a href="javascript:;">全部</a>
						</a-menu-item>
						<a-menu-item v-for="item in applyItems" :key="item.dictValue">
							<a href="javascript:;">{{item.dictValue}}</a>
						</a-menu-item>
					</a-menu>
				</a-dropdown>
				<!--<a-dropdown overlayClassName="hospital-dropdown-overlay" class="hospital-dropdown-link">-->
					<!--<a class="ant-dropdown-link">-->
						<!--{{searchGroupLableKey}}-->
						<!--<a-icon type="down"/>-->
					<!--</a>-->
					<!--<a-menu slot="overlay" style="height: 300px; overflow: hidden; overflow-y: scroll;"-->
					        <!--@click="onClickSearchGroupItemKey">-->
						<!--<a-menu-item key="-2">-->
							<!--<a href="javascript:;">全部</a>-->
						<!--</a-menu-item>-->
						<!--<a-menu-item v-for="item in groupItems" :key="item.id">-->
							<!--<a href="javascript:;">{{item.groupName}}</a>-->
						<!--</a-menu-item>-->
					<!--</a-menu>-->
				<!--</a-dropdown>-->
			</div>
		</div>
		<div class="page-content page-turn-content">
			<a-table
					class="hospital-table"
					v-if='jobData'
					:pagination="false"
					:loading="loading"
					:rowSelection="rowSelection"
					:rowKey="record => record.id"
					:columns="columns"
					:dataSource="jobData"
					size="middle"
			>
				<template slot-scope='text,record,index' slot='op'>
					<div class="table-tr-handle">
						<a href="javascript:;" @click="editJob(text,record,index)"
						   class="cf-mr10">编辑</a>
						<a href="javascript:;" v-if="record.delFlag == 1"
						   @click="updateStatus(text,record,index)"
						   class="cf-mr10">启用</a>
						<a href="javascript:;" v-else @click="updateStatus(text,record,index)"
						   class="cf-mr10">禁用</a>
					</div>
				</template>
			</a-table>
		</div>
		<page-model @close="closeModel" :visible="visible">
			<job-add
					v-if="visible"
					@close="closeModel"
					:editJobRow="editJobRow"
					:editJobId="editJobId"
					:treeData="treeData"
			></job-add>
		</page-model>
		<page-model @close="closeModel" :visible="statusIsVisible">
			<div class="form-model-main reset-model">
				<div class="add-page-content dept-page-content sure-content">
					<template v-if="delParams.userable">
						<div class="title">启用操作</div>
						<div class="content">确定要启用吗？</div>
					</template>
					<template v-else>
						<div class="title">禁用操作</div>
						<div class="content">确定要禁用吗？</div>
					</template>
					<div class="confrim-footer">
						<a-button type="primary" class="cf-mr10" @click="submitUpStatus">确定
						</a-button>
						<a-button @click="statusIsVisible=false">取消</a-button>
					</div>
				</div>
			</div>
		</page-model>
		<page-model @close="closeModel" :visible="anaIsVisible">
			<div class="form-model-main reset-model">
				<div class="add-page-content dept-page-content">
					<div class="title">指派分析人员</div>
					<a-tree-select
							:getPopupContainer="triggerNode => triggerNode.parentNode"
							style="width: 100%;position:relative"
							:dropdownStyle="{ maxHeight: '300px', overflow: 'auto' }"
							placeholder="请选择"
							:selectable="false"
							allowClear
							autoExpandParent
							showSearch
							@change="onChange"
							:treeData="treeData"
					>
					</a-tree-select>
					<div class="confrim-footer">
						<a-button type="primary" class="cf-mr10" @click="submitAna">确定
						</a-button>
						<a-button @click="anaIsVisible=false">取消</a-button>
					</div>
				</div>
			</div>
		</page-model>
	</div>
</template>

<script>
  import JobAdd from "./addjob.vue";

  const columns = [
    {
      title: "序号",
      customRender: (text, record, index) => `${index + 1}`
    },
    {
      title: "检测项目名称",
      dataIndex: "applyItem"
    },
    {
      title: "患者分组",
      dataIndex: "groupName",
      customRender: (text, record, index) => {
        if (!record.groupName) {
          return '-'
        } else {
          return record.groupName
        }
      }
    },
    {
      title: "流程名称",
      dataIndex: "pipelineName"
    },
    {
      title: "分析人员",
      dataIndex: "analyzeName",
      customRender: (text, record, index) => {
        if (!record.analyzeName) {
          return '-'
        } else {
          return record.analyzeName
        }
      }
    },
    {
      title: "创建时间",
      dataIndex: "createTime"
    },
    {
      title: "更新时间",
      dataIndex: "updateTime"
    },
    {
      title: "操作",
      scopedSlots: {customRender: "op"}
    }
  ];
  export default {
    data() {
      return {
        columns,
        jobData: [],
        selectedData: [], //选中数据
        selectedRowKeys: [], //选中id
        loading: false, //表格加载
        visible: false, // 添加作业弹窗
        statusIsVisible: false, //启用禁用弹窗
        anaIsVisible: false, //指派人员弹窗
        analyzeId: '', //选中的指派人员id
        enable: 1, //禁用或者启用
        editJobRow: {}, //编辑数据
        editJobId: '', //编辑id
        paramsStr: {
          types: 'DS',
          applyItem: '',
          groupId: '',
        },
        applyItems: [],
        groupItems: [],
        searchLableKey: '检测项目',
        searchGroupLableKey: '患者分组',
        delParams: {
          id: null,
          userable: null
        },
        setAnaParams: {
          userId: '',
          ids: []
        },
        treeData: []
      };
    },
    components: {JobAdd},
    computed: {
      rowSelection() {
        const {selectedRowKeys} = this;
        return {
          selectedRowKeys,
          onChange: (selectedRowKeys, selectedRows) => {
            this.selectedRowKeys = selectedRowKeys
            this.selectedData = selectedRows
          },
          getCheckboxProps: record => ({
            props: {
              disabled: record.name === "Disabled User", // Column configuration not to be checked
              name: record.name
            }
          })
        };
      }
    },
    mounted() {
      this.getJobList();
      this.findDeptList();
      this.getApplyItem();
      this.getGroupItem();
    },
    methods: {
      getApplyItem() {
        this.$get("info/commonDict?dictType=applyItem").then(res => {
          this.applyItems = res.data.data.rows;
        });
      },
      getGroupItem() {
        this.$get("patientgroup").then(res => {
          this.groupItems = res.data.data;
          this.groupItems.push({groupName: '-', id: '-1'});
        });
      },
      getJobList() {
        this.$get('/allconfig/autojob', this.paramsStr).then(res => {
          this.jobData = res.data.data;
        })
      },
      onClickSearchApplyItemKey({key}) {
        if (key == '-1') {
          this.paramsStr.applyItem = '';
          this.searchLableKey = '检测项目';
        } else {
          let textValue = '';
          this.paramsStr.applyItem = key;
          this.applyItems.forEach(function (item, i) {
            if (item.dictValue == key) {
              textValue = item.dictValue;
              return;
            }
          })
          this.searchLableKey = textValue;
        }
        this.getJobList();
      },
      onClickSearchGroupItemKey({key}) {
        if (key == null || key == -2) {
          this.paramsStr.groupId = '';
          this.searchGroupLableKey = '患者分组';
        } else {
          let textValue = '';
          this.paramsStr.groupId = key;
          this.groupItems.forEach(function (item, i) {
            if (item.id == key) {
              textValue = item.groupName;
              return;
            }
          })
          this.searchGroupLableKey = textValue;
        }
        this.getJobList();
      },
      addAnalyze() {
        if (!this.selectedRowKeys.length) {
          this.$message.warning('请选择数据后进行设置')
        } else {
          this.anaIsVisible = true;
        }
      },
      editJob(text, record, index) {
        this.visible = true;
        this.editJobRow = record;
        this.editJobId = record.id;
      },
      closeModel() {
        this.visible = false;
        this.statusIsVisible = false;
        this.anaIsVisible = false;
        this.editJobRow = {};
        this.selectedData = [];
        this.selectedRowKeys = [];
        this.getJobList();
      },
      updateStatus(text, record, index) {
        this.delParams.id = record.id;
        this.delParams.userable = record.delFlag == 1 ? true : false;
        this.statusIsVisible = true;
      },
      submitUpStatus() {
        this.$put(`/allconfig/autojob/${this.delParams.id}?userable=${this.delParams.userable}`, {
          "Content-Type": "application/json"
        }).then(
          res => {
            this.delSuccess(res.data);
          }
        );
      },
      submitAna() {
        if (!this.setAnaParams.userId) {
          this.$message.warning('请选择分析人员');
          return false;
        }
        this.setAnaParams.ids = this.selectedRowKeys;
        this.$get('/allconfig/autojob/appointsAnalyze', this.setAnaParams).then(res => {
          this.delSuccess(res.data);
        })
      },
      delSuccess(data) {
        if (data.code == 1) {
          this.$message.success("操作成功");
          this.closeModel();
        } else {
          this.$message.error("操作失败!");
        }
      },
      // 查找组织机构
      findDeptList() {
        this.$get("/dept/findDeptTreeList", {
          pageSize: 999999,
          pageNum: 1
        }).then(res => {
          this.treeData = res.data.data;
          this.treeData.map(item => {
            item.title = item.deptName;
            item.selectable = true;
            item.key = item.deptId;
            item.value = item.deptId.toString();
            item.selectable = false;
            item.children.map(tip => {
              tip.selectable = false;
              tip.title = tip.deptName;
              tip.selectable = false;
              tip.key = tip.deptId;
              tip.value = tip.deptId.toString();
              if (tip.children.length == 0 && tip.userList && tip.userList.length > 0) {
                tip.children = this.treeNodeChildren(tip.userList);
              }
              return tip;
            });
            return item;
          });
          this.treeData = this.treeData;
          this.total = 1000;
        });
      },
      treeNodeChildren(data) {
        let result = [];
        data.map((item, index) => {
          let json = item;
          json.title = item.nickName;
          json.selectable = true;
          json.key = "userId_" + item.userId;
          json.value = item.nickName;
          json.isLeaf = true;
          result.push(json);
        });
        return result;
      },
      onChange(value, label, extra) {
        let tag = value ? extra.triggerNode.eventKey.toString().substring(7) : '';
        this.setAnaParams.userId = tag;
      },
    }
  };
</script>

<style lang="scss" scoped>
	.ant-btn + .ant-btn {
		margin-left: 5px;
	}

	.sure-content .content {
		padding: 0;
		border: none;
	}
</style>